/**
 * @generated SignedSource<<8563ce980dca8dd43c60ad2d8f42f7e7>>
 * @relayHash 1dea07045fdc805115ac232cb227baba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID deae66b71a25de9fe27a948c315bf1284489f18bdc8b2d162d225e511711fe78

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useFeedTypeSelectorFeedTypeSelectorRefreshMutation$variables = {
  feedTab: string;
};
export type useFeedTypeSelectorFeedTypeSelectorRefreshMutation$data = {
  readonly updateUserPreferences: {
    readonly feedTab: string | null | undefined;
  } | null | undefined;
};
export type useFeedTypeSelectorFeedTypeSelectorRefreshMutation = {
  response: useFeedTypeSelectorFeedTypeSelectorRefreshMutation$data;
  variables: useFeedTypeSelectorFeedTypeSelectorRefreshMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "feedTab"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "feedTab",
            "variableName": "feedTab"
          }
        ],
        "kind": "ObjectValue",
        "name": "userPreferences"
      }
    ],
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "updateUserPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "feedTab"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useFeedTypeSelectorFeedTypeSelectorRefreshMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFeedTypeSelectorFeedTypeSelectorRefreshMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1dea07045fdc805115ac232cb227baba",
    "id": "deae66b71a25de9fe27a948c315bf1284489f18bdc8b2d162d225e511711fe78",
    "metadata": {},
    "name": "useFeedTypeSelectorFeedTypeSelectorRefreshMutation",
    "operationKind": "mutation",
    "text": "mutation useFeedTypeSelectorFeedTypeSelectorRefreshMutation($feedTab:String!){updateUserPreferences(userPreferences:{feedTab:$feedTab}){feedTab}}"
  }
};
})();

(node as any).hash = "6a96de700fa7869ef1acedccaf8591a7";

export default node;
